import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Загружаем тему из localStorage при старте
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('app-theme');
    return saved && ['simple', 'dark', 'light'].includes(saved) ? saved : 'simple';
  });

  // Сохраняем тему в localStorage при изменении
  useEffect(() => {
    localStorage.setItem('app-theme', theme);
    // Применяем класс к body для глобальных стилей
    document.body.className = `theme-${theme}`;
  }, [theme]);

  const value = {
    theme,
    setTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};